export const parseApiAmount = (val) => {
  if (val == null) return 0;
  if (typeof val === "number") {
    return Number.isFinite(val) ? val : 0;
  }
  if (typeof val !== "object" || !Array.isArray(val.d)) return 0;

  const { d, s } = val;
  if (!d?.length) return 0;

  let str = String(d[0]);
  for (let i = 1; i < d.length; i += 1) {
    str += String(d[i]).padStart(7, "0");
  }

  const unsigned = Number(str);
  if (!Number.isFinite(unsigned)) return 0;

  return s === -1 ? -unsigned : unsigned;
};

export const formatCurrency = (amount, currency = "KRW") => {
  const n = typeof amount === "number" ? amount : parseApiAmount(amount);

  if (!Number.isFinite(n) || n === 0) return "—";

  return new Intl.NumberFormat(currency === "KRW" ? "ko-KR" : "en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(n);
};
